import { render, staticRenderFns } from "./SendEmailTemplatePopup.vue?vue&type=template&id=20f9abb4&"
import script from "./SendEmailTemplatePopup.vue?vue&type=script&lang=js&"
export * from "./SendEmailTemplatePopup.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailTemplatePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports